module.exports = __webpack_public_path__ + "static/media/050-Abbey Road Taphousejpeg.23b5213a.jpeg";